// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
export default {
  detailedSameDay: {
    sameDay: 'LT',
    lastDay: '[Yesterday]',
    lastWeek: 'L'
  }
}


// WEBPACK FOOTER //
// ./src/scripts/constants/MomentCalendarPresets.js